import { graphqlPost } from "api/graphqlClient";
import restClient from "api/restClient";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { actions as executionsActions } from "containers/Executions/Executions.reducer";
import { executionsCreateOperationMutation } from "containers/Executions/Executions.type";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

/**
 * Create Execution
 * @param  {Object} formData
 * @return {Object} Response from API
 */
export function* createExecution({ promise, params }) {
    try {
        const createExecutionAPI = yield graphqlPost(params);
        yield put({
            type: executionsActions.CREATE_EXECUTION_SUCCESSFUL,
        });
        yield put({
            type: executionsActions.STORE_EXECUTION_DATA,
            iri: `/execution/${createExecutionAPI?.data?.create_execution?.id}`,
            response: createExecutionAPI?.data?.create_execution,
        });
        yield call(promise.resolve, createExecutionAPI?.data?.create_execution);
    } catch (error) {
        yield put({
            type: executionsActions.CREATE_EXECUTION_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Update Single Execution
 * @param  {Object} id ID of a Execution
 * @param  {Object} params
 * @return {Object} Response from API
 */
export function* updateSingleExecution({ promise, id, params }) {
    try {
        const updateSingleExecutionAPI = yield graphqlPost(params);
        yield put({
            type: executionsActions.UPDATE_EXECUTION_SUCCESSFUL,
        });
        yield put({
            type: executionsActions.STORE_EXECUTION_DATA,
            iri: `/execution/${id}`,
            response: updateSingleExecutionAPI?.data?.update_execution,
        });
        yield call(promise.resolve);
    } catch (error) {
        yield put({
            type: executionsActions.UPDATE_EXECUTION_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

export function* createExecutionOperation({ promise, variables }) {
    try {
        yield graphqlPost({
            query: executionsCreateOperationMutation,
            variables,
        });
        yield put({
            type: executionsActions.CREATE_EXECUTION_OPERATION_SUCCESSFUL,
        });
        yield call(promise.resolve);
    } catch (error) {
        yield put({
            type: executionsActions.CREATE_EXECUTION_OPERATION_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Operation on all executions
 * @param  {Object} params
 * @return {Object} Response from API
 */
export function* executionsOperation({ promise, operation }) {
    try {
        yield restClient.patch(`/execution`, { operation });
        yield put({
            type: executionsActions.EXECUTIONS_OPERATION_SUCCESSFUL,
        });
        yield call(promise.resolve);
    } catch (error) {
        yield put({
            type: executionsActions.EXECUTIONS_OPERATION_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Register action to watcher
 */
export default [
    takeEvery(executionsActions.START_CREATE_EXECUTION, createExecution),
    takeLatest(executionsActions.START_UPDATE_EXECUTION, updateSingleExecution),
    takeEvery(executionsActions.START_CREATE_EXECUTION_OPERATION, createExecutionOperation),
    takeLatest(executionsActions.START_EXECUTIONS_OPERATION, executionsOperation),
];
